<template>
  <div class="container-search" @click="close()">
    <div class="search-list" @click="close()">
      <div class="searchBlock row mx-0 justify-content-center justify-content-sm-start" @click.stop>
        <input ref="searchInput" v-model="search" type="text" placeholder class="searchBar">
        <div class="searchResult my-2 h-100">
          <router-link
            v-for="elem in filterData"
            :key="elem.id"
            :to="elem.acf.type"
            class="searchText"
          >
            <div class="results py-2" @click="close()" v-html="elem.title.rendered" />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
// axios
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

export default {
  name: 'Search',
  props: {
    searchActive: {
      type: Boolean
    }
  },
  data() {
    return {
      result: [],
      search: '',
      fetchedPage: 0,
      nbFetched: 100
    }
  },
  computed: {
    removedSpace(url) {
      return url.replace(/\s+/g, '-')
    },
    filterData() {
      if (this.search.length >= 1) {
        const people = [...this.result]
          .filter(elem =>
            elem.title.rendered
              .toLowerCase()
              .startsWith(this.search.toLowerCase())
          )
          .map(person => {
            const type = `${person.acf.type}s/${person.slug}`
              .replace(/\s+/g, '-')
              .toLowerCase()
              .replace(/^/, '/')
              
            return {
              ...person,
              acf: {
                ...person.acf,
                type
              }
            }
          })

        return people
      }
      return []
    }
  },
  created() {
    this.fetchAllPersons()
  },
  methods: {
    close() {
      this.search = ''
      //   this.searchBool = false;
      this.$emit('close')
    },
    async fetchAllPersons() {
      try {
        let persons = []
        while(persons.length >= this.fetchedPage * this.nbFetched) {
          this.fetchedPage++
          const split = await axios.get(`${process.env.VUE_APP_URL}/wp-json/wp/v2/people?filter[meta_key]=priority&filter[meta_compare]==&filter[meta_value]=1&per_page=${this.nbFetched}&page=${this.fetchedPage}`)
          persons = persons.concat(split.data)
        }
        this.result = persons
      } catch(err) {
        console.error(err)
      }
    }
    // searchToggle() {
    //   this.searchBool = !this.searchBool;
    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.searchBar {
  border-radius: 0;
  font-family: "Fortescue-light";
  letter-spacing: 0.05em;
  height: 40px;
  color: #fff;
  font-size: 25px;
  border-bottom: 2px solid;
  background: transparent;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  position: relative;
  z-index: 1;
  font-size: 18px;
}

.searchBar:focus {
  outline: transparent;
}

.searchBar::placeholder {
  color: #fff;
  opacity: 0.5;
}

.searchResult {
  background-color: transparent;
  // max-width: 300px;
}

.results {
  padding-bottom: 15px;
  padding-top: 15px;
  letter-spacing: 0.05em;
  font-size: 18px;
  font-family: "Fortescue-semibold";

  @media only screen and (max-width: 600px) {
    font-size: 18px;
  }
}

.searchBlock {
  position: absolute;
  padding-left: 40px;
  padding-right: 40px;
  /* to move the line from top down */
  padding-top: 35px;
  right: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.95);
  height: 100vh;
  max-width: 300px;

  @media only screen and (max-width: 600px) {
    max-width: none;
  }
}

.container-search {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 98;
}

.searchText {
  color: #fff;
  text-decoration: none;
  font-size: 30px;
}

.search-icon {
  width: 50px;
}

a:hover {
  color: #d69a2d;
}

@media only screen and (max-width: 600px) {
  .searchBlock {
    /* to move the line from top down */
    padding-top: 150px;
  }
  .searchText {
    margin-left: auto;
    margin-right: auto;
    width: 50%;
    text-align: center;
  }
  .searchResult {
    width: 100%;
  }
}
</style>
